module.exports = __webpack_public_path__ + "img/虚拟仿真.acbb6b59.svg";